import { HaloclineException } from '@halo/exceptions/halocline.exception'

export class SessionValidationFailedException extends HaloclineException {
    public constructor(public readonly source: Error) {
        super(source.message)
        Object.setPrototypeOf(this, SessionValidationFailedException.prototype)
    }
}
